<template>
  <v-row justify="center">
    <v-dialog v-model="$store.state.commentModal" max-width="600px" persistent>
      <v-card class="overflow-y-auto" id="scroll-target" style="max-height:600px">
        <v-app-bar color="primary" dark rounded flat>
          <v-toolbar-title>コメント一覧</v-toolbar-title>
        </v-app-bar>
        <v-container class="overflow-y-auto" id="scroll-target" style="max-height:400px" ref='messageDisplay'>
          <v-card-text>
            <v-card v-for="(comment, i) in sortArrays(record.commentList)"
              :key="i"
              rounded
              outlined
              class="mb-2">
              <v-card-text>
                <v-row>
                  <v-col cols="2" class="text-center">
                    <v-avatar class="text-center">
                      <v-img class="" :src="comment.commentUserPhotoURL"></v-img>
                    </v-avatar>  
                  </v-col>
                  <v-col cols="10">
                    <div class="mb-2">
                      <div class="d-flex justify-space-between">
                        <router-link :to="userDetailLink(comment.commentUserId)">
                          {{ comment.commentUserName }}
                        </router-link>
                        <span>{{ commentAt(comment.commentAt) }}</span>
                      </div>
                    </div>
                    <h4>
                      {{ comment.commentContent }}
                    </h4>
                  </v-col>
                </v-row>
              </v-card-text>     
            </v-card>
          </v-card-text>
          <template>
            <v-form ref="comment_form" @submit.prevent>
              <v-container>
                <v-text-field
                  v-model="commentContent"
                  :append-icon="'mdi-send'"
                  filled
                  clear-icon="mdi-close-circle"
                  clearable
                  label="コメント"
                  type="text"
                  :counter="50"
                  @click:append="send"
                  :rules="[rules.required, rules.max50]"
                ></v-text-field>
              </v-container>
            </v-form>
          </template>
          <v-card-text class="text-right">
            <v-btn color="secondary" @click.stop='closeCommentModal'>閉じる</v-btn>
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
export default {
  name: 'CommentToRecordModalComponent',
  props: {
    record: Object,
  },
  data(){
    return {
      commentData:{},
      commentContent: '',
      rules: {
        required: v => !!v || '必須', 
        max50: v => (v || '').length <= 50 || '最大50文字',
      },
    }
  },
  computed:{
    userDetailLink(){
      return function(userId){
        return userId === this.loginUserId ? { name: 'User'} : { name: 'OtherUser', params: { userId: userId }}
      }
    },
    commentAt(){
      return function(commentAt){
        return moment.unix(commentAt).format('YYYY-MM-DD HH:mm');
      }
    },
    ...mapGetters(['loginUserId'])
  },
  updated(){
    this.scrollBottom();
  },
  methods:{
    sortArrays(arrays) {
      return _.orderBy(arrays, (comment => comment.commentAt), 'asc');
    },
    closeCommentModal(){
      this.toggleCommentModal()
      this.$refs.comment_form.reset();
    },
    send(){
      if(!this.$refs.comment_form.validate()) return
      const recordId = this.record.recordId;
      const comment = {
        commentUserId: this.loginUserId,
        commentContent: this.commentContent,
        commentAt: new Date()
      }
      this['record/addComment']({ comment: comment, recordId: recordId });
      this.$refs.comment_form.reset();
    },
    scrollBottom() {
				const messageDisplay = this.$refs.messageDisplay;
				messageDisplay.scrollTop = messageDisplay.scrollHeight;
		},
    ...mapActions(['toggleCommentModal','record/addComment','fetchComments'])
  }
}
</script>
<style scoped lang="scss">
a {
  text-decoration: none;
}
</style>
